/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EntitySequence } from './EntitySequence';
import {
    EntitySequenceFromJSON,
    EntitySequenceFromJSONTyped,
    EntitySequenceToJSON,
} from './EntitySequence';
import type { SequenceAlign } from './SequenceAlign';
import {
    SequenceAlignFromJSON,
    SequenceAlignFromJSONTyped,
    SequenceAlignToJSON,
} from './SequenceAlign';
import type { SequenceType } from './SequenceType';
import {
    SequenceTypeFromJSON,
    SequenceTypeFromJSONTyped,
    SequenceTypeToJSON,
} from './SequenceType';

/**
 * 
 * @export
 * @interface Session
 */
export interface Session {
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    id: string;
    /**
     * 
     * @type {Array<EntitySequence>}
     * @memberof Session
     */
    entitySequences: Array<EntitySequence>;
    /**
     * 
     * @type {Array<SequenceAlign>}
     * @memberof Session
     */
    alignedSequences?: Array<SequenceAlign>;
    /**
     * 
     * @type {SequenceType}
     * @memberof Session
     */
    sequenceType: SequenceType;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    sequenceClassLabelSingular: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    sequenceClassLabelPlural: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    documentationLabel: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    documentationUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    alignmentToolLabel: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    alignmentOptionsDescription: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    maskingResidue?: string;
    /**
     * Whether or not it is possible to create a hitlist from this session
     * @type {boolean}
     * @memberof Session
     */
    canCreateHitList: boolean;
    /**
     * Label of HitList to be created (e.g., `Hit List`). Null if hit list creation inactive 
     * @type {string}
     * @memberof Session
     */
    createHitListLabel: string;
    /**
     * A reason why hit list creation is disabled, e.g.`Contains Antibody Clones from multiple Screening Campaigns.` May be null (for example for data where we never expect hiy list creation).
     * @type {string}
     * @memberof Session
     */
    cannotCreateHitListMessage?: string;
}

/**
 * Check if a given object implements the Session interface.
 */
export function instanceOfSession(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "entitySequences" in value;
    isInstance = isInstance && "sequenceType" in value;
    isInstance = isInstance && "sequenceClassLabelSingular" in value;
    isInstance = isInstance && "sequenceClassLabelPlural" in value;
    isInstance = isInstance && "documentationLabel" in value;
    isInstance = isInstance && "documentationUrl" in value;
    isInstance = isInstance && "alignmentToolLabel" in value;
    isInstance = isInstance && "alignmentOptionsDescription" in value;
    isInstance = isInstance && "canCreateHitList" in value;
    isInstance = isInstance && "createHitListLabel" in value;

    return isInstance;
}

export function SessionFromJSON(json: any): Session {
    return SessionFromJSONTyped(json, false);
}

export function SessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Session {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entitySequences': ((json['entitySequences'] as Array<any>).map(EntitySequenceFromJSON)),
        'alignedSequences': !exists(json, 'alignedSequences') ? undefined : ((json['alignedSequences'] as Array<any>).map(SequenceAlignFromJSON)),
        'sequenceType': SequenceTypeFromJSON(json['sequenceType']),
        'sequenceClassLabelSingular': json['sequenceClassLabelSingular'],
        'sequenceClassLabelPlural': json['sequenceClassLabelPlural'],
        'documentationLabel': json['documentationLabel'],
        'documentationUrl': json['documentationUrl'],
        'alignmentToolLabel': json['alignmentToolLabel'],
        'alignmentOptionsDescription': json['alignmentOptionsDescription'],
        'maskingResidue': !exists(json, 'maskingResidue') ? undefined : json['maskingResidue'],
        'canCreateHitList': json['canCreateHitList'],
        'createHitListLabel': json['createHitListLabel'],
        'cannotCreateHitListMessage': !exists(json, 'cannotCreateHitListMessage') ? undefined : json['cannotCreateHitListMessage'],
    };
}

export function SessionToJSON(value?: Session | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'entitySequences': ((value.entitySequences as Array<any>).map(EntitySequenceToJSON)),
        'alignedSequences': value.alignedSequences === undefined ? undefined : ((value.alignedSequences as Array<any>).map(SequenceAlignToJSON)),
        'sequenceType': SequenceTypeToJSON(value.sequenceType),
        'sequenceClassLabelSingular': value.sequenceClassLabelSingular,
        'sequenceClassLabelPlural': value.sequenceClassLabelPlural,
        'documentationLabel': value.documentationLabel,
        'documentationUrl': value.documentationUrl,
        'alignmentToolLabel': value.alignmentToolLabel,
        'alignmentOptionsDescription': value.alignmentOptionsDescription,
        'maskingResidue': value.maskingResidue,
        'canCreateHitList': value.canCreateHitList,
        'createHitListLabel': value.createHitListLabel,
        'cannotCreateHitListMessage': value.cannotCreateHitListMessage,
    };
}

